import { createContext } from 'react';

export const BlockListContext = createContext();
